import { getLocalString } from './getLocalString';

// e.g. '21:20'
export function getHoursAndMinutes(dateString) {
    return getLocalString(dateString, { hour: '2-digit', minute: '2-digit' });
}
